import { z } from 'zod';
import { PAYMENT_METHODS } from '@/types/paymentMethods';

export { PAYMENT_METHODS };

export const NOTIFICATION_TIMEOUTS = {
  ERROR: 8000,
  SUCCESS: 5000,
  WARNING: 6000,
} as const;

export const FILE_CONSTRAINTS = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'application/pdf'],
} as const;

export const entrySchema = z.object({
  competenceDate: z
    .string()
    .min(1, 'Data de competência é obrigatória')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida'),
  description: z
    .string()
    .min(3, 'Descrição deve ter no mínimo 3 caracteres')
    .max(1000, 'Descrição deve ter no máximo 1000 caracteres'),
  observation: z
    .string()
    .max(5000, 'Observação deve ter no máximo 5000 caracteres')
    .optional(),
  totalCost: z
    .string()
    .min(1, 'Valor total é obrigatório')
    .refine(val => {
      const num = parseFloat(val.replace(/[^\d,.-]/g, '').replace(',', '.'));
      return !isNaN(num) && num > 0;
    }, 'Valor total deve ser maior que 0'),
  supplierId: z.string().optional(),
  costCenterId: z.string().optional(),
  documentNumber: z
    .string()
    .max(100, 'Número do documento deve ter no máximo 100 caracteres')
    .optional(),
  recipient: z
    .string()
    .max(255, 'Destinatário deve ter no máximo 255 caracteres')
    .optional(),
});
